import { useTranslation } from 'react-i18next';
import { useGiftConfig } from '../hooks/use-gift-config';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { $ReferralGiftsData } from '~/models/referral-gifts';

export const useActivityTDK = (): { title: string; description: string; keywords: string } => {
  const { t } = useTranslation();
  const { region } = useAtomValue($Locale);

  const { giftType = '', amountStr = '' } = useAtomValue($ReferralGiftsData);
  const { description } = useGiftConfig({ giftType, region, amountStr });

  const title = t('couponShare_reflow_header');

  const keywords = t('inbox_message_postInspos_title');

  return {
    title,
    description,
    keywords,
  };
};
